/* eslint-disable no-unused-vars */

import styled from 'styled-components';

export const Background = styled.div`
	position: absolute;
	width: 8rem;
	z-index: 1300;
	top: 0;
	right: 3rem;
	@media (max-width: 800px) {
		top: 3.5rem;
		right: 9rem;
		width: 4rem;
	}
`;

export const ModalWrapper = styled.div`
	width: 100%;
	height: 100%;
	box-shadow: 0 5px 16px rgba(0, 0, 0, 0.2);
	background: #fff;
	color: #000;
	border-radius: 6px;
	padding: 0.2rem;
	border: 2px #d9d5d2 solid;
`;

export const ModalContent = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);

	min-height: 1.8rem;
	height: max-content;
	@media (max-width: 800px) {
		grid-template-columns: 1fr;
		min-height: 6rem;
		height: max-content;
	}
`;

export const Container = styled.div`
	width: 100%;
	height: 100%;
	z-index: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	& + div {
		border-left: 1px solid;
		border-color: #d9d5d2;
	}
	@media (max-width: 800px) {
		& + div {
			border-left: 0;
			border-top: 1px solid;
			border-color: #d9d5d2;
		}
	}

	img,
	svg {
		width: 20px;
		height: 20px;
	}
`;

export const ButtonControl = styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	width: fit-content;
	width: 100%;
	height: 100%;
	background: none;
	cursor: pointer;
	:hover {
		text-decoration: none;
		background-color: #e6dcd3;
		height: 85%;
		border-radius: 4px;
	}
	&.active {
		height: 85%;
		background-color: #e6dcd3;
		border-radius: 4px;
	}
`;
